/**
 * Data Access Utilities
 * 
 * This module contains utilities for accessing data from MaterializedTableData.
 */

import { MaterializedTableData } from '@/lib/engine';

/**
 * Parameters for getCellValue function
 */
export interface GetCellValueParams {
  /** The MaterializedTableData instance */
  data: MaterializedTableData | null;
  /** The row index */
  rowIndex: number;
  /** The column name */
  columnName: string;
}

/**
 * Get a cell value from MaterializedTableData
 */
export function getCellValue({ data, rowIndex, columnName }: GetCellValueParams): unknown {
  // Safety check for data
  if (!data || !data.table) {
    return null;
  }
  
  // Find the column index in the schema using exact name matching
  const columnIndex = data.table.schema.fields.findIndex(
    (f: { name: string }) => f.name === columnName
  );
  
  // If column not found in schema, return null
  if (columnIndex === -1) {
    return null;
  }
  
  try {
    // Get the column and then the value
    const column = data.table.getChildAt(columnIndex);
    if (!column) {
      return null;
    }
    
    const value = column.get(rowIndex);
    
    return value;
  } catch (err) {
    return null;
  }
} 